"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.shadows = exports.level64 = exports.level16 = exports.level8 = exports.level4 = exports.level0 = void 0;
exports.level0 = 'none';
exports.level4 = '0px 0.3px 0.9px rgba(0, 0, 0, 0.05), 0px 1.6px 3.6px rgba(0, 0, 0, 0.08)';
exports.level8 = '0px 0.6px 1.8px rgba(0, 0, 0, 0.108), 0px 3.2px 7.2px rgba(0, 0, 0, 0.132)';
exports.level16 = '0px 1.2px 3.6px rgba(0, 0, 0, 0.108), 0px 6.4px 14.4px rgba(0, 0, 0, 0.132)';
exports.level64 = '0px 4.8px 14.4px rgba(0, 0, 0, 0.18), 0px 25.6px 57.6px rgba(0, 0, 0, 0.22)';
exports.shadows = {
    level0: exports.level0,
    level4: exports.level4,
    level8: exports.level8,
    level16: exports.level16,
    level64: exports.level64,
};
//# sourceMappingURL=shadows.js.map